
<template>
  <div>
    <keep-alive>
      <router-view
        style="height: 100%"
        :style="{ background: this.$store.state.pageBackground }"
        v-if="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view
      style="height: 100%"
      :style="{ background: this.$store.state.pageBackground }"
      v-if="!$route.meta.keepAlive"
    ></router-view>
  </div>
</template>

<script>
import watermark from "./watermark";
export default {
  mounted: function () {
    //
    this.updateTableHeight();

    window.onresize = () => {
      this.updateTableHeight();
    };
    this.init();
  },
  methods: {
    updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 270);
    },
     //水印
  init() {
    let name = this.$store.state.user.userName;
    //水印
    setTimeout(() => {
      let str = name;
      if (str) {
        watermark.set(str);
      }
      this.init();
    }, 1000);
  },
  },
};
</script>
<style lang="sass">
@import '~vue-xpc/src/style/index.scss'
@import '../element-variables.scss'
</style>



// WEBPACK FOOTER //
// App.vue?db028088